export default __webpack_public_path__ + "static/media/deliverit-how.91a13dbb.gif";